import { render, staticRenderFns } from "./TokenExpiredMessage.vue?vue&type=template&id=362b243a&scoped=true"
import script from "./TokenExpiredMessage.vue?vue&type=script&lang=ts"
export * from "./TokenExpiredMessage.vue?vue&type=script&lang=ts"
import style0 from "./TokenExpiredMessage.vue?vue&type=style&index=0&id=362b243a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362b243a",
  null
  
)

export default component.exports